import { Sleep } from '../utils/utils';
import { SME_CON } from './api-connection';
import { Wait_For_Auth, isHotLoad } from '../utils/utils';
import { SMEAuth } from 'sme-auth-client';
import { SME_AUTH } from './globalVars';
import { GLOBAL_VARS } from './globalVars';


const SYNC_AUTH_URL = import.meta.env.VITE_SYNC_AUTH_URL;
const SERVER_WS_SYNC_URL = import.meta.env.VITE_WS_SYNC_URL;
const SERVER_HTTP_SYNC_URL = import.meta.env.VITE_HTTP_SYNC_URL;



const Auth = () => {
   var auth = null;
   var graphql = null;
   var api = null;
   var no_auth = false;

   const init_without_auth = (caller = null) => {
      return new Promise(async (resolve, reject) => {
         try {
            if (caller === null) {
               console.error('DEBUG init_auth -- caller is null');
               return;
            }

            no_auth = true;
            // console.warn('DEBUG init_auth: caller: ', caller);

            // SYNC_AUTH_URL

            // throw new Error('hot-load init_without_auth ');
            
            ({ auth, graphql, api } = await SMEAuth.createServices({
               authServerUrl: SYNC_AUTH_URL,
               apiUrl: SERVER_HTTP_SYNC_URL,
               wsUrl: SERVER_WS_SYNC_URL,
               debug: false, // Enable logging
               keyPrefix: 'sme-scoring-app',
               skipAuthRedirect: true,
               onAuthFailure: () => {
                  // Handle authentication failure
                  console.error('onAuthFailure not implemented');
               }
            }));
            
            // throw new Error('hot-load init_without_auth ');
            // console.log('auth: ', auth); 
            // console.log('graphql: ', graphql); 

            
            resolve(true);
         } catch (error) {
            console.error('ERROR - init_without_auth: ', error);
            resolve(false);
         }
      });
   }

   const init_auth = (caller = null) => {
      return new Promise(async (resolve, reject) => {
         try {
            if (caller === null) {
               console.error('DEBUG init_auth -- caller is null');
               return;
            }
            // console.warn('DEBUG init_auth: caller: ', caller);

            ({ auth, graphql, api } = await SMEAuth.createServices({
               authServerUrl: SYNC_AUTH_URL,
               apiUrl: SERVER_HTTP_SYNC_URL,
               wsUrl: SERVER_WS_SYNC_URL,
               debug: false, // Enable logging
               keyPrefix: 'sme-scoring-app',
               onAuthFailure: () => {
                  // Handle authentication failure
                  console.error('onAuthFailure not implemented');
               }
            }));


            const authCodeData = SMEAuth.parseAuthCallback();
            // console.log('DEBUG authCodeData: ', authCodeData);

            if (authCodeData?.code) {
               // console.log('DEBUG authCodeData: ', authCodeData);
               // Exchange auth code for tokens
               auth.exchangeCodeForToken(authCodeData.code).then((result) => {
                  // console.log('DEBUG auth.exchangeCodeForToken: ', result);
                  window.history.replaceState({}, document.title, window.location.pathname);
               }).catch(error => {
                  console.error('Authentication failed:', error);
               });
            }

            window.history.replaceState({}, document.title, window.location.pathname);

            if (await auth.isAuthenticatedAsync()) {
               // console.log('\n\n LOGGED IN \n\n');
            }

            
            resolve(true);
         } catch (error) {
            console.error('ERROR - init_auth: ', error);
            resolve(false);
         }
      });
   }

   const is_authenticated = () => {
      return new Promise(async (resolve, reject) => {
         if (auth !== null) {
            const result = await auth.isAuthenticatedAsync();
            resolve(result);
         } else {
            resolve(false);
         }
      });
   }


   const auth_redirect = () => {

      if (isHotLoad()) {
         console.error('hot-load auth_redirect - skipping');
         return;
      }


      // Ensure HTTPS protocol for redirect URL to prevent mixed content errors
      const redirectUrl = window.location.href.replace(/^http:/, 'https:');
      auth.redirectToCentralizedLogin({
         redirectUrl: redirectUrl
      });
   }

   const login = () => {
      return new Promise(async (resolve, reject) => {
         // console.warn('DEBUG login');
         const loginResult = await is_authenticated();
         // console.log('---------------------------------- redirectUrl ', window.location.href);
         // await new Promise(resolve => setTimeout(resolve, 2_500));
         // console.log('loginResult: ', loginResult);

         if (!loginResult) {
            auth_redirect();
         }
         resolve(loginResult);
      });
   }

   const logout = () => {
      return new Promise(async(resolve, reject) => {
            auth.logout();
         resolve(true);
      });
   }

   const get_token = () => {
      return new Promise((resolve, reject) => {
         try {
            const deviceId = auth.getDeviceIdentifier();
            // console.warn('DEBUG get_token: deviceId: ', deviceId);
            const token = auth.getToken();
            const token_obj = {
               token: token,
               refreshToken: token,
               deviceID: deviceId,
            }
            
            resolve(token_obj);
         } catch (error) {
            console.warn('WARNING - get_token - root: ', error);
          reject(error);  
         }
     });
   }

   const get_user_info = () => {
      return new Promise((resolve, reject) => {
         const userInfo = auth.getUser()
         resolve(userInfo);
      });
   }

   const try_refresh_token = () => {
      return new Promise((resolve, reject) => {

         if (isHotLoad()) {
            console.error('hot-load try_refresh_token - skipping');
            resolve(true);
            return;
         }

         auth.refreshToken().then((result) => {
            resolve(result);
         }).catch((error) => {
            console.error('ERROR - try_refresh_token: ', error);
            if (GLOBAL_VARS.server_connection) {
               auth_redirect();
            }
            reject(error);
         });
      });
   }


   const init = (caller = null) => { return init_auth(caller); }

   const get_graphql = () => {
      return graphql;
   }
   const get_api = () => {
      return api;
   }

   const get_no_auth = () => {
      return no_auth;
   }


   return { init, init_without_auth, login, logout, get_token, is_authenticated, get_user_info, try_refresh_token, get_graphql, get_api, get_no_auth }
}





const build_sme_con = () => {
   return new Promise(async (resolve) => {
      await Wait_For_Auth(SME_AUTH);
      SME_AUTH.is_authenticated().then(async (authResult) => {
         const sme_con = new SME_CON(SME_AUTH);
         while (!sme_con.ready) {
            if (sme_con.client === false) {
               resolve(null);
               return
            }
            await Sleep(50);
         }
         resolve(sme_con);
      }).catch(() => {
         resolve(null);
      });
   });
}

export { Auth, build_sme_con }
export default Auth; 